// r2/shopify_build/theme/assets/sticky-cart.js — CC-02
// Reveals a sticky bottom add-to-cart bar (mobile only) when the main
// product CTA scrolls out of view. Requires:
//   - <form class="product-form">…<button name="add">…</button></form>
//   - <div class="gl-sticky-cart">…</div> rendered once near </body>
(function () {
  if (window.matchMedia('(min-width: 769px)').matches) return;
  var bar = document.querySelector('.gl-sticky-cart');
  var anchor = document.querySelector('form.product-form button[name="add"]');
  if (!bar || !anchor) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    });
  }, { rootMargin: '0px 0px -40px 0px' });
  io.observe(anchor);
})();
